import React, { useEffect, useMemo, useState } from 'react';
import { Modal } from "react-bootstrap";
import isNull from '../../../../../../../../../../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../../utils/FormValidator';
import DatePicker from '../../../../../../../../../../../General/DatePicker';
import ModalHeader from '../../../../../../../../../../../Setup/Shared/ModalHeader';
import SuperSearchList from '../../../../../../../../../../../shared/SuperSearch/SuperSearchList';
import Loader from '../../../../../../../../../../../shared/Loader/Loader';
import DeleteConfirmatiom from '../../../../../../../../../../../General/DeleteConfirmation';

// const TobaccoUseData = [
//     { display: 'Non-Smoker', value: 'NonSmoker' },
//     { display: 'Ex-Smoker', value: 'ExSmoker' },
//     { display: 'Smoker', value: 'Smoker' },
//     { display: 'Current non smoker but past smoking history unknown', value: 'CurrentNonSmokerPastHistoryUnknown' },
//     { display: 'Current every day smoker', value: 'CurrentEveryDaySmoker' },
//     { display: 'Light cigarette smoker (1-9 cigs/day)', value: 'LightCigaretteSmoker' },
//     { display: 'Moderate cigarette smoker (10-19 cigs/day)', value: 'ModerateCigaretteSmoker' },
//     { display: 'Heavy cigarette smoker (23-39 cigs/day)', value: 'HeavyCigaretteSmoker' },
//     { display: 'Very Heavy cigarette smoker (40+ cigs/day)', value: 'VeryHeavyCigaretteSmoker' },
//     { display: 'Cigar smoker', value: 'CigarSmoker' },
//     { display: 'Pipe smoker', value: 'PipeSmoker' },
//     { display: 'Heavy tobacco smoker', value: 'HeavyTobaccoSmoker' },
//     { display: 'Light tobacco smoker', value: 'LightTobaccoSmoker' },
//     { display: 'Current some day smoker', value: 'CurrentSomeDaySmoker' },
// ];

const AddNewTobaccoUse = (props) => {
    const { isOpenTobaccoUse, onClose, tobaccoUseData, setIsRecordSaved, onDeleteTobaccoUse, patientID, IsEditAllowed } = { ...props }
    const API_URL = enumUtil.controller.General
    let TobaccoUse_Modal = {
        TobaccoUse: tobaccoUseData.TobaccoUse || "",
        EffectiveDate: tobaccoUseData.EffectiveDate || "",
        Notes: tobaccoUseData.Notes || ""
    }
    let valModal = {}
    let ValidationModal = {
        TobaccoUseVal: "",
        EffectiveDateVal: "",
    }
    const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
    const [tobaccoUseDD, setTobaccoUseDD] = useState([]);
    const [tobaccoUseID, setTobaccoUseID] = useState();
    const [tobaccoUseValidationModal, setTobaccoUseValidationModal] = useState(ValidationModal)
    const [tobaccoUseSaveUpdateModal, setTobaccoUseSaveUpdateModal] = useState({})
    const [mainTobaccoUseModal, setMainTobaccoUseModal] = useState(TobaccoUse_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [onTobaccoUseSaved, setOnTobaccoUseSaved] = useState(false)
    const [del, setDel] = useState(false)
    // const [searchDropdown, setSearchDropdown] = useState(false);
    const [is, setIs] = useState(false);

    const LoadDD = (searchParam) => {
        setTobaccoUseDD([])
        ServerRequestProtected(API_URL + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientHistory,
        }).then((response) => {
            setTobaccoUseDD(response)
        }).catch((error) => {
        })
    }
    useEffect(() => {
        LoadDD()
    }, [])

    useEffect(() => {
        // setPracticeID(PracticeID)
        if (tobaccoUseData.PatientHistoryID != null) {
            setDel(true)
            setTobaccoUseID(tobaccoUseData.PatientHistoryID)
        } else {
            if (!onTobaccoUseSaved) {
                setTobaccoUseID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (!isNull(tobaccoUseID)) {
            // setIsLoading(true)
            // ServerRequestProtected(API_URL + "/FindByID", 'post', {
            //     "ID": tobaccoUseID,
            //     "TableName": enumUtil.enumAPITableName.TobaccoUse
            // }).then((response) => {
            //     setIsLoading(false)
            //     setMainTobaccoUseModal(response)
            // }).catch((error) => {
            //     NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            //     setIsLoading(false)
            // })
        }
    }, [tobaccoUseID])

    const isEffectiveDateDisabled = useMemo(() => {
        return ["Non-Smoker",
        "Current non smoker but past smoking history unknown"].includes(mainTobaccoUseModal.TobaccoUse);
    },[mainTobaccoUseModal?.TobaccoUse]);

    const TobaccoUseValidation = async () => {

        let ValidationModal = {
            TobaccoUseVal: FormValidator(
                mainTobaccoUseModal.TobaccoUse,
                enumUtil.enumValidationType.Required,
                'Tobacco Use',
            ),
            EffectiveDateVal: isEffectiveDateDisabled ? "":
                FormValidator(
                mainTobaccoUseModal.EffectiveDate,
                enumUtil.enumValidationType.Required,
                'Effective Date',
            ),

        }
        await setTobaccoUseValidationModal(ValidationModal)
        valModal = ValidationModal
    }

    const handleSaveTobaccoUse = async () => {
        if(!IsEditAllowed) return;
        await TobaccoUseValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setTobaccoUseSaveUpdateModal(tobaccoUseSaveUpdateModal)
            let data = {
                PatientID: patientID,
                HistoryType: "Social History",
                HistorySubType: "Tobacco Use",
                ...tobaccoUseSaveUpdateModal
            };

            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientHistory,
                ID: tobaccoUseID,
                Data: { ...data },
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
                        setIsRecordSaved(true)
                        setTobaccoUseID(response.id)
                        setOnTobaccoUseSaved(true)
                        onClose()
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }

    const handleChange = (e) => {
        let { name, value } = e.target
        let modal = { ...mainTobaccoUseModal };
        let saveModal = { ...tobaccoUseSaveUpdateModal }
        modal[name] = value
        setMainTobaccoUseModal(modal)
        for (var property in TobaccoUse_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setTobaccoUseSaveUpdateModal(saveModal)
    }

    const handleDateChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainTobaccoUseModal };
        let saveModal = { ...tobaccoUseSaveUpdateModal }
        modal[type] = FormatedDate
        setMainTobaccoUseModal(modal)
        for (var property in TobaccoUse_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setTobaccoUseSaveUpdateModal(saveModal)
    }

    const TobaccoUseName = () => {
        return (
            <p className="heading">Add New Tobacco Use</p>
        )
    }

    const handleSelectedData = (selectedData, name, type, mode) => {
        setIs(true)
        let modal = { ...mainTobaccoUseModal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === "TobaccoUse") {
                modal[name] = selectedData.display
                tobaccoUseSaveUpdateModal[name] = selectedData.value + "";
                if(["Non-Smoker","Current non smoker but past smoking history unknown"].includes(selectedData.value)){
                    modal['EffectiveDate'] = ""
                    tobaccoUseSaveUpdateModal['EffectiveDate'] = "";
                }
                // setProviderID(selectedData.value + "")
            } else if (name === "ProviderID") {
                modal[name] = selectedData.display
                tobaccoUseSaveUpdateModal[name] = selectedData.value + "";
                // setProviderID(selectedData.value + "")
            }
        } else if (type === 'server' && !isNull(selectedData)) {
            // if (name === "TobaccoUse") {
            //     modal[name] = selectedData.display
            //     tobaccoUseSaveUpdateModal[name] = String(selectedData.value);
            // }

        } else {

            modal[name] = ''
            tobaccoUseSaveUpdateModal[name] = ''
        }
        setMainTobaccoUseModal(modal)
        return selectedData
    }

    const handleDeleteModal = () => {
        setisOpenDeleteAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenDeleteAlert(false);
    }
    const onDelete = () => {
        props?.setIsRecordSaved(true);
        setisOpenDeleteAlert(false);
        onClose();
    }

    let DeleteConfirmation = "";
    if (isOpenDeleteAlert) {
        DeleteConfirmation = (
            <DeleteConfirmatiom
                isOpenAlert={isOpenDeleteAlert}
                hideReason={true}
                API_URL={API_URL}
                TableName={enumUtil.enumAPITableName.PatientHistory}
                ID={String(tobaccoUseID)}
                onCloseDelete={onCloseDelete}
                onClose={onDelete}
            />
        );
    }
    let DeletePopup = "";
    if (del) {
        DeletePopup = (
            <button
                className={
                    props?.IsDeleteAllowed
                      ? 
                    "btn-icon-transparent"
                      : 
                      "btn-icon-transparent delete-btn-disabled"
                } onClick={handleDeleteModal}>
                <span className="icon"><i className="icon-delete"></i></span>
                <span className="title">Delete</span>
            </button>
        );
    }

    return (
        <Modal show={isOpenTobaccoUse} onHide={isOpenTobaccoUse} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design
">
            <Modal.Body>
                {DeleteConfirmation}
                {isLoading ? <Loader /> : null}
                <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={TobaccoUseName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
                <div className="">
                    <div className=''>
                        <div className="input mb-12">
                            <div className="form-group input">
                                <label className="pb-3px">Tobacco Use</label>
                                <div className={`input form-group ar-multiple-br m-0 ${tobaccoUseValidationModal.TobaccoUseVal ? 'error' : ''}`}>
                                    <SuperSearchList
                                        type="client"
                                        id='TobaccoUse'
                                        name='TobaccoUse'
                                        searchValue={mainTobaccoUseModal.TobaccoUse}
                                        data={tobaccoUseDD}
                                        onChange={handleChange}
                                        getSelectedData={handleSelectedData}
                                        icon={'Simple'}
                                        sup_btn='sup_btn'
                                        sup_inp='superSearchVisitInp'
                                        inputError={tobaccoUseValidationModal.TobaccoUseVal}
                                    />
                                    {tobaccoUseValidationModal.TobaccoUseVal}
                                </div>
                            </div>
                        </div>
                        {isEffectiveDateDisabled ? <></> :
                        <div className="d-flex align-items-end gap-12 w-50 mb-12">
                            <div className={`input mb-0 ${tobaccoUseValidationModal.EffectiveDateVal ? 'error' : ''} w-100`}>
                                <label className="pb-3px">Effective Date</label>
                                <DatePicker
                                    value={mainTobaccoUseModal.EffectiveDate}
                                    className='mb-0'
                                    handleCalendarChangefunc={date => handleDateChange(date, 'EffectiveDate')} />
                                {tobaccoUseValidationModal.EffectiveDateVal}
                            </div>
                        </div>}
                        <div className='input' >
                            <label className="pb-3px">Notes</label>
                            <textarea 
                                rows="3" 
                                className="form-control"
                                id='Notes'
                                name='Notes'
                                value={mainTobaccoUseModal.Notes}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-end gap-2">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSaveTobaccoUse}>Save</button>
            </div>
        </Modal>
    )
}

export default AddNewTobaccoUse